import IconTarget from '../components/enablement/shared/icons/IconTarget';
import IconBuild from '../components/enablement/shared/icons/IconBuild';
import IconLabel from '../components/enablement/shared/icons/IconLabel';
import * as urls from '../actions/urlTypes';

export const _xtabNavItems = [
  {
    id: 'xtabDropdown',
    title: 'Dropdown',
    icon: IconTarget,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/essentials/crosstabPOC/dropdown`,
  },
  {
    id: 'xtabTable',
    title: 'Table',
    icon: IconBuild,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/essentials/crosstabPOC/table`,
  },
  {
    id: 'xtabDummy',
    title: 'Dummy',
    icon: IconLabel,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/essentials/crosstabPOC/dummy`,
  },
];